
export interface FormAnswers {
  timeInBusiness?: string;
  monthlyRevenue?: string;
  industry?: string;
  fundingPurpose?: string;
  fundingAmount?: string;
  goal?: string;
  creditScore?: string;
}

export interface QualificationResult {
  isQualified: boolean;
  disqualificationReason?: string;
  tier?: string;
}

export function checkQualification(answers: FormAnswers): QualificationResult {
  const { timeInBusiness, monthlyRevenue, fundingAmount } = answers;

  // Check time in business - less than 4 months is a soft warning, not disqualification
  if (timeInBusiness === '<4mo') {
    return {
      isQualified: true,
      tier: 'startup'
    };
  }

  // Check monthly revenue - under 10k is a soft warning
  if (monthlyRevenue === '<10k') {
    return {
      isQualified: true,
      tier: 'micro'
    };
  }

  // Determine tier based on funding amount
  let tier = 'standard';
  if (fundingAmount) {
    const amount = parseInt(fundingAmount);
    if (!isNaN(amount)) {
      if (amount < 50000) tier = 'small';
      else if (amount < 100000) tier = '50-99k';
      else if (amount < 150000) tier = '100-149k';
      else if (amount < 250000) tier = '150-249k';
      else tier = '250k+';
    }
  }

  return {
    isQualified: true,
    tier
  };
}

export function getTimeBucket(time?: string): string {
  if (!time) return '';
  if (time === '<4mo') return 'under_4';
  if (time === '4-12mo') return '4_12';
  if (time === '12-24mo') return '12_24';
  return '24_plus';
}

export function getRevenueBucket(revenue?: string): string {
  if (!revenue) return '';
  if (revenue === '<10k') return 'under_10';
  if (revenue === '10-29k') return '10_29';
  if (revenue === '30-49k') return '30_49';
  if (revenue === '50-99k') return '50_99';
  return '100_plus';
}

export function getCreditBucket(credit?: string): string {
  if (!credit) return 'not_provided';
  if (credit === '<600') return 'under_600';
  if (credit === '600-649') return '600_649';
  if (credit === '650-699') return '650_699';
  return '700_plus';
}
